import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../theme.scss'

Vue.use(BootstrapVueIcons)
Vue.use(BootstrapVue)
